import { isUTXOAddress } from '@bigmi/core';
import { InvalidAddressError } from 'viem';
export function getAddress(address) {
    if (!isUTXOAddress(address)) {
        throw new InvalidAddressError({ address });
    }
    return address;
}
//# sourceMappingURL=getAddress.js.map